/* Coquinou - upsells dans le panier (huile de massage + jeu de cartes) + logos de paiement */
(function(){
  var R=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var L=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
  var TXS={
    fr:{h:'Profitez encore plus de Coquinou avec…',b:'Ajouter',e:'Une erreur est survenue.'},
    en:{h:'Get the most out of Coquinou with…',b:'Add',e:'Something went wrong.'},
    de:{h:'Hol noch mehr aus Coquinou heraus mit…',b:'Hinzufügen',e:'Ein Fehler ist aufgetreten.'}
  };
  var TX=TXS[L]||TXS.fr;
  var PAY_IMG='https://cdn.shopify.com/s/files/1/0815/4556/0175/files/coquinou-paiements.png?v=1791259542&width=900';
  /* Produits proposés, dans l'ordre d'affichage */
  var UPS=[
    {v:67880851112047,h:'huile-de-massage-passion-paradis-tropical',p:2499,img:'https://cdn.shopify.com/s/files/1/0815/4556/0175/files/huile-coquinou-flacon.jpg?v=179125099&width=9000&width=200',
     n:{fr:'Huile de Massage Passion – Paradis Tropical',en:'Passion Massage Oil – Tropical Paradise',de:'Massageöl Passion – Tropisches Paradies'}},
    {v:67880851374191,h:'jeu-cartes-50-positions-bondage',p:2499,img:'https://cdn.shopify.com/s/files/1/0815/4556/0175/files/cartes-1.jpg?v=179125789&width=9001&width=200',
     n:{fr:'Jeu de cartes – 50 Positions de Bondage',en:'Card game – 50 Bondage Positions',de:'Kartenspiel – 50 Bondage-Stellungen'}}
  ];
  UPS.forEach(function(u){
    u.url=R+'products/'+u.h;
    fetch(u.url+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){if(!p){return;}if(p.price){u.p=p.price;}if(p.featured_image){var s=p.featured_image;u.img=(s.indexOf('//')===0?'https:'+s:s)+(s.indexOf('?')>-1?'&':'?')+'width=200';}}).catch(function(){});
  });
  var IDS=UPS.map(function(u){return u.v;});
  function money(c,cur){try{return new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:cur||'EUR'}).format(c/100);}catch(e){return (c/100).toFixed(2)+' €';}}
  var st=document.createElement('style');
  st.textContent='#cqd .cqup{margin:16px 0 8px}#cqd .cquph{font-weight:800;font-size:15px;line-height:1.3;color:#4a1426;margin:0 0 10px}#cqd .cqupc{display:flex;align-items:center;gap:12px;background:#5c2232;border-radius:12px;padding:12px}#cqd .cqupc+.cqupc{margin-top:10px}#cqd .cqupl{display:flex;align-items:center;gap:12px;flex:1 1 auto;min-width:0;text-decoration:none!important;color:inherit!important;cursor:pointer}#cqd .cqupl:hover .cqupn{text-decoration:underline}#cqd .cqupc img{width:64px!important;height:64px!important;border-radius:8px;object-fit:cover;flex:0 0 auto;margin:0!important;background:#fbe6ee}#cqd .cqupi{flex:1 1 auto;min-width:0}#cqd .cqupn{color:#f4a3c0;font-size:14px;line-height:1.3}#cqd .cqupp{color:#f4a3c0;font-size:15px;font-weight:700;margin-top:4px}#cqd .cqupb{flex:0 0 auto;background:transparent;border:1.5px solid #f4a3c0;color:#f4a3c0;border-radius:10px;padding:9px 14px;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap}#cqd .cqupb:hover{background:#f4a3c0;color:#5c2232}#cqd .cqupb:disabled{opacity:.6;cursor:wait}#cqd .cqdpy.cqpayimg{font-size:0;line-height:0;text-align:center}#cqd .cqdpy.cqpayimg img{display:block;width:100%;max-width:360px;height:auto;margin:10px auto 0}';
  document.head.appendChild(st);
  function payLogos(){
    var py=document.querySelector('#cqd .cqdpy');
    if(!py||py.classList.contains('cqpayimg')) return;
    py.classList.add('cqpayimg');
    py.innerHTML='<img src="'+PAY_IMG+'" alt="Mastercard, Visa, Pay, Amex, Klarna, Carte Bancaire, Apple Pay" width="706" height="64" loading="lazy">';
  }
  function card(u,cur){
    var name=u.n[L]||u.n.fr;
    return '<div class="cqupc"><a class="cqupl" href="'+u.url+'"><img src="'+u.img+'" alt="'+name+'"><div class="cqupi"><div class="cqupn">'+name+'</div><div class="cqupp">'+money(u.p,cur)+'</div></div></a><button type="button" class="cqupb" data-v="'+u.v+'">+ '+TX.b+'</button></div>';
  }
  var busy=false;
  function inject(){
    var body=document.getElementById('cqdb');
    if(!body||busy||body.querySelector('.cqup')) return;
    busy=true;
    fetch(R+'cart.js').then(function(r){return r.json();}).then(function(cart){
      busy=false;
      var inCart={};cart.items.forEach(function(i){inCart[i.variant_id]=1;});
      var paid=cart.items.some(function(i){return IDS.indexOf(i.variant_id)<0&&i.final_line_price>0;});
      var list=UPS.filter(function(u){return !inCart[u.v];});
      if(!paid||!list.length||body.querySelector('.cqup')) return;
      var d=document.createElement('div');
      d.className='cqup';
      d.innerHTML='<div class="cquph">'+TX.h+'</div>'+list.map(function(u){return card(u,cart.currency);}).join('');
      d.querySelectorAll('.cqupb').forEach(function(btn){
        btn.addEventListener('click',function(){
          var b=this; b.disabled=true;
          fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(b.getAttribute('data-v'),10),quantity:1}]})}).then(function(r){
            if(!r.ok){return r.json().then(function(e){alert(e.description||TX.e);b.disabled=false;});}
            if(window.cqRC){window.cqRC();}
          }).catch(function(){b.disabled=false;});
        });
      });
      body.appendChild(d);
    }).catch(function(){busy=false;});
  }
  function start(){
    payLogos();
    var body=document.getElementById('cqdb');
    if(!body) return;
    new MutationObserver(function(){inject();}).observe(body,{childList:true});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
